import RouteMap from "./RouteMap";
import { formatArrival, bareDuration, pickupLabel } from "./utils";

// Chrome 60-safe — no ?. / flex gap / backdrop-filter
const SquareEta = function (props) {
  var s = props.s;
  var pickup = props.pickup;
  var routes = props.routes;
  var error = props.error;
  var single = props.single;
  var onMapLoad = props.onMapLoad;
  var showMap = props.showMap !== false;
  var pickLabel = function (r) {
    if (!r) return "";
    return !showMap && r.fullLabel ? r.fullLabel : r.label;
  };
  var r0 = routes[0];
  // map-mode cards, sized against the panel below the map
  var mapWrapped = routes.length > 2;
  var mc = s.nmCards(
    mapWrapped ? 2 : 1,
    mapWrapped ? Math.ceil(routes.length / 2) : routes.length,
    s.mapPanelBox.square,
  );

  // Full-screen data view — stacked, with the cards wrapping two-up.
  if (!showMap) {
    var badge = (
      <span style={s.nmBadge}>
        <span style={s.nmDot} /> Live Traffic ETA
      </span>
    );

    // pickup shown once for the whole list, not repeated per card

    var from = (
      <span style={s.nmFrom}>
        <span style={s.nmFromLabel}>From</span>
        <span style={s.nmFromValue}>{pickupLabel(pickup) || "—"}</span>
      </span>
    );

    if (error) {
      return (
        <div style={s.nmRoot}>
          <div style={s.nmGlow} />
          <div style={s.nmGlowLow} />
          <div style={s.nmTopBar}>{badge}</div>
          <div
            style={Object.assign({}, s.nmBody, {
              justifyContent: "center",
              alignItems: "center",
            })}
          >
            <div style={s.nmError}>{error}</div>
          </div>
        </div>
      );
    }

    if (single) {
      var arrival = formatArrival(r0 && r0.durationSecs);
      return (
        <div style={s.nmRoot}>
          <div style={s.nmGlow} />
          <div style={s.nmGlowLow} />
          <div style={s.nmTopBar}>
            {badge}
            {r0 && r0.traffic ? (
              <span
                style={Object.assign({}, s.nmPill, { color: r0.traffic.color })}
              >
                <span style={s.nmPillDot} />
                {r0.traffic.label}
              </span>
            ) : null}
          </div>

          <div style={s.nmBody}>
            <div style={s.nmJourney}>
              <div style={s.nmRail}>
                <span style={s.nmRailDot} />
                <span style={s.nmRailLine} />
                <span style={s.nmRailPin} />
              </div>
              <div style={s.nmStops}>
                <div style={s.nmStopLabel}>From</div>
                <div style={s.nmStopValue}>{pickupLabel(pickup) || "—"}</div>
                <div style={s.nmStopGap} />
                <div style={s.nmStopLabel}>To</div>
                <div style={s.nmStopValue}>{pickLabel(r0)}</div>
              </div>
            </div>

            <div>
              <div style={s.nmHeroLabel}>Estimated time</div>
              <div style={s.nmHeroRow}>
                <span style={s.nmHeroValue}>
                  {(r0 && bareDuration(r0.duration)) || "--"}
                </span>
              </div>
            </div>

            <div style={s.nmStats}>
              <div style={s.nmTile}>
                <div style={s.nmTileLabel}>Distance</div>
                <div style={s.nmTileValue}>{(r0 && r0.distance) || "--"}</div>
              </div>
              {arrival ? (
                <div style={Object.assign({}, s.nmTile, { marginRight: 0 })}>
                  <div style={s.nmTileLabel}>Arrives</div>
                  <div style={s.nmTileValue}>{arrival}</div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    }

    // 3+ destinations wrap two-up; 1–2 stay full width
    var wrapped = routes.length > 2;
    var c = s.nmCards(
      wrapped ? 2 : 1,
      wrapped ? Math.ceil(routes.length / 2) : routes.length,
    );
    return (
      <div style={s.nmRoot}>
        <div style={s.nmGlow} />
        <div style={s.nmGlowLow} />
        <div style={s.nmTopBar}>
          {badge}
          {s.nmFromInline ? from : null}
        </div>
        {s.nmFromInline ? null : <div style={s.nmFromRow}>{from}</div>}
        <div
          style={Object.assign({}, s.nmList, s.nmListRow, {
            flexDirection: "row",
            flexWrap: "wrap",
            alignContent: "center",
          })}
        >
          {routes.map(function (r) {
            return (
              <div
                key={r.index}
                style={Object.assign(
                  {},
                  c.card,
                  c.tint(r.traffic && (r.traffic.fill || r.traffic.color)),
                  { flexBasis: wrapped ? "42%" : "100%" },
                )}
              >
                <span
                  style={Object.assign({}, c.accent, {
                    background: r.traffic ? c.railTint : r.color,
                  })}
                />
                <div style={c.label}>{r.label || pickLabel(r)}</div>
                <div style={c.row}>
                  <span style={c.time}>{bareDuration(r.duration)}</span>
                  <span style={c.dist}>{r.distance}</span>
                </div>
                <div style={c.foot}>
                  {r.traffic ? (
                    <span
                      style={Object.assign({}, c.pill, {
                        color: r.traffic.color,
                      })}
                    >
                      <span style={c.pillDot} />
                      {r.traffic.label}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  var map = (
    <RouteMap
      s={s}
      pickup={pickup}
      routes={routes}
      single={single}
      onMapLoad={onMapLoad}
    />
  );

  if (single && !error) {
    return (
      <div style={Object.assign({}, s.wrapper, { flexDirection: "column" })}>
        <div style={s.squarePanel}>
          <div style={s.squareHeader}>
            <span style={s.badge}>
              <span style={s.dotLive} /> Live Traffic ETA
            </span>
            {r0 && r0.traffic ? (
              <span
                style={Object.assign({}, s.squareTrafficPill, {
                  color: r0.traffic.color,
                })}
              >
                {r0.traffic.label}
              </span>
            ) : null}
          </div>

          <div
            style={Object.assign({}, s.squareTo, {
              fontSize: s.squareMins.fontSize,
            })}
          >
            To: {pickLabel(r0)}
          </div>

          <div
            style={Object.assign({}, s.squareKmRow, {
              flexDirection: "column",
              alignItems: "center",
            })}
          >
            <span style={s.squareMins}>
              {r0 && r0.duration ? "in " + r0.duration + "." : ""}
            </span>
            <span
              style={Object.assign({}, s.squareKm, {
                marginRight: 0,
                fontSize: parseFloat(s.squareKm.fontSize) * 0.7 + "px",
              })}
            >
              {(r0 && r0.distance) || "--"}
            </span>
          </div>
        </div>

        {showMap ? <div style={s.squareMapSide}>{map}</div> : null}
      </div>
    );
  }

  return (
    <div style={Object.assign({}, s.wrapper, { flexDirection: "column" })}>
      {showMap ? (
        <div style={Object.assign({}, s.mapSide, { flex: 0.85 })}>{map}</div>
      ) : null}

      <div style={s.panel}>
        <div style={s.header}>
          <span style={s.badge}>
            <span style={s.dotLive} /> Live Traffic ETA
          </span>
        </div>

        {error ? (
          <div style={s.content}>
            <div style={s.error}>{error}</div>
          </div>
        ) : (
          <div
            style={Object.assign({}, s.nmList, s.nmListRow, {
              flexDirection: "row",
              flexWrap: "wrap",
              alignContent: "center",
            })}
          >
            {routes.map(function (r) {
              return (
                <div
                  key={r.index}
                  style={Object.assign(
                    {},
                    mc.card,
                    mc.tint(r.traffic && (r.traffic.fill || r.traffic.color)),
                    { flexBasis: mapWrapped ? "42%" : "100%" },
                  )}
                >
                  <span
                    style={Object.assign({}, mc.accent, {
                      background: r.traffic ? mc.railTint : r.color,
                    })}
                  />
                  <div style={mc.label}>{pickLabel(r)}</div>
                  <div style={mc.row}>
                    <span style={mc.time}>{bareDuration(r.duration)}</span>
                    <span style={mc.dist}>{r.distance}</span>
                  </div>
                  <div style={mc.foot}>
                    {r.traffic ? (
                      <span
                        style={Object.assign({}, mc.pill, {
                          color: r.traffic.color,
                        })}
                      >
                        <span style={mc.pillDot} />
                        {r.traffic.label}
                      </span>
                    ) : null}
                    <span style={mc.routeChip}>
                      A &rarr; {String.fromCharCode(66 + r.index)}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default SquareEta;
